import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon } from 'lucide-react';
import { mockData } from '../utils/mockData';
export const EvidenceTable = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const filteredData = mockData.sidebar.bodycamFootage.filter(item => item.title.toLowerCase().includes(search.toLowerCase()) || item.id.toLowerCase().includes(search.toLowerCase()));
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const currentData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  return <main className="flex-grow p-6 overflow-auto" style={{
    backgroundImage: 'radial-gradient(circle at center, #2d4c6b 0%, #1f1f1f 100%)'
  }} data-id="element-226">
      <div className="max-w-[1200px] mx-auto" data-id="element-227">
        <div className="mb-6 relative" data-id="element-228">
          <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#888888]" size={20} data-id="element-229" />
          <input type="text" placeholder="Search evidence..." value={search} onChange={e => {
          setSearch(e.target.value);
          setCurrentPage(1);
        }} className="w-full pl-10 pr-4 py-2 bg-[#1a1a1a] border border-[#444444] rounded-lg text-[#e0e0e0] placeholder:text-[#888888] focus:outline-none focus:border-[#4a90e2]" data-id="element-230" />
        </div>
        <div className="border border-[#444444] rounded-lg overflow-hidden bg-[#1a1a1a]" data-id="element-231">
          <table className="w-full" data-id="element-232">
            <thead className="bg-[#1a1a1a]" data-id="element-233">
              <tr data-id="element-234">
                <th className="px-4 py-3 text-left text-sm font-semibold" data-id="element-235">
                  Title
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold" data-id="element-236">
                  ID
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold" data-id="element-237">
                  Date
                </th>
              </tr>
            </thead>
            <tbody data-id="element-238">
              {currentData.map(item => <tr key={item.id} className="border-t border-[#444444] hover:bg-[#2a2a2a]" data-id="element-239">
                  <td className="px-4 py-3" data-id="element-240">
                    <button onClick={() => navigate(`/transcript/${item.id}`)} className="text-[#4a90e2] hover:underline text-left" data-id="element-241">
                      {item.title}
                    </button>
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-242">{item.id}</td>
                  <td className="px-4 py-3 text-sm" data-id="element-243">{item.date}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="mt-4 flex items-center justify-between" data-id="element-244">
          <div className="text-sm text-[#888888]" data-id="element-245">
            Showing {(currentPage - 1) * itemsPerPage + 1} to{' '}
            {Math.min(currentPage * itemsPerPage, filteredData.length)} of{' '}
            {filteredData.length} results
          </div>
          <div className="flex gap-2" data-id="element-246">
            {Array.from({
            length: totalPages
          }, (_, i) => <button key={i} onClick={() => setCurrentPage(i + 1)} className={`px-3 py-1 rounded ${currentPage === i + 1 ? 'bg-[#4a90e2] text-white' : 'bg-[#1a1a1a] text-[#888888] hover:bg-[#2a2a2a]'}`} data-id="element-247">
                  {i + 1}
                </button>)}
          </div>
        </div>
      </div>
    </main>;
};